import { Component, OnInit } from '@angular/core';
import { ProfileService } from './profile.service';
import { Router } from '@angular/router'
import * as moment from 'moment-timezone';
import { ToastrService } from 'ngx-toastr';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import * as AWS from 'aws-sdk/global';
import * as S3 from 'aws-sdk/clients/s3';
import { S3Service } from '../file-complain/s3.service';
import { NgbPanelChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { SafeResourceUrl } from '@angular/platform-browser';
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styles: []
})
export class ProfileComponent implements OnInit {
  @BlockUI('image-list') block: NgBlockUI;
  selectedFiles: FileList;
  images: any;
  Images: any;
  disabled: boolean;
  maxImageSizeInKb: number = 2097152; //equivalent of 2Mb;
  fileToUploadName: string = '';
  profileLogoBase64: string = '';
  displayLogoUrl: SafeResourceUrl;
  logoPlaceholder: string;
  ProfileData: any = {
    age: '',
    email: '',
    name: {
      first: '',
      last: ''
    },
    mobile_number: '',
    profile_image: ''

  };

  DOB: any;

  changeData: any = {
    old_password: '',
    new_password: ''

  };


  public isCollapsed = true;
  currentDate = new Date();
  // current day
  currentDay = ("0" + this.currentDate.getDate()).slice(-2);
  // current month
  currentMonth = ("0" + (this.currentDate.getMonth() + 1)).slice(-2);
  // current year
  currentYear = this.currentDate.getFullYear();
  selectedDOB: string;

  public beforeChange($event: NgbPanelChangeEvent) {

    if ($event.panelId === 'preventchange-2') {
      $event.preventDefault();
    }

    if ($event.panelId === 'preventchange-3' && $event.nextState === false) {
      $event.preventDefault();
    }
  };

  constructor(private profileService: ProfileService,
    private router: Router,
    private toastr: ToastrService,
    private s3Service: S3Service) {
    this.logoPlaceholder =
      '../../../../assets/brandEdit/placeholder100.png';
  }

  ngOnInit() {
    this.ProfileData = this.profileService.ProfileData
    this.DOB = this.profileService.ProfileData.age
    this.selectedDOB = this.profileService.ProfileData.age

    var d = new Date(this.DOB),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    console.log('dateeeeeeeeeeee', [day, month, year].join('-'))
    this.ProfileData.age = [day, month, year].join('-')
    // return [year, month, day].join('-');

  }

  selectDOB(dob) {
    console.log('DOB -_---->>', dob);
    this.selectedDOB = dob.year + '-' + dob.month + '-' + dob.day;
  }

  submit(data) {
    var birthDate = new Date(this.selectedDOB);
    var age = this.currentDate.getFullYear() - birthDate.getFullYear();
    // if (age < 18) {
    //   this.toastr.error('DOB should be 18 years or above it.');
    // } else {   }
    var userEntered = new Date(this.selectedDOB); // valueAsNumber has no time or timezone!
    var now = new Date();
    var today = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
    if (userEntered.getTime() < today.getTime() || userEntered.getTime() == today.getTime()) {
      const profileDetails = JSON.parse(JSON.stringify(data))
      profileDetails.age = this.selectedDOB
      profileDetails.email = profileDetails.email.toLowerCase()
      console.log('in register', profileDetails)
      this.profileService.updateProfile(profileDetails)
        .then(() => {
          this.toastr.success('Your Profile Updated Successfully!');
          this.router.navigate(['/profile'])
        }, (error) => {
          console.log('fail callback', error.status)
          if (error.status == 400) {
            this.toastr.error(error.error.message);
          }
        }).catch(e => {
          console.log('catch', e);
        });
    } else {
      this.toastr.error('Invalid date.');
    }
  }


  selectFile(event) {
    this.selectedFiles = event.target.files;
    const file = this.selectedFiles.item(0);
    this.s3Service.uploadfile(file).then((url) => {
      console.log(';url in select file', url)
      this.Images = url.Location
      const str = url.key
      const res = str.split("/");
      const file_name = res[res.length - 1];
      this.ProfileData.profile_image = file_name
    })
  }

  changePassword(data) {
    console.log('in register', data)
    this.profileService.changePassword(data)
      .then(() => {
        this.changeData = {};
        this.toastr.success('Your Password Changed Successfully!');
        this.router.navigate(['/profile'])
      }, (error) => {
        console.log('fail callback', error.status)
        if (error.status == 400) {
          this.toastr.error(error.error.message);
        }
      }).catch(e => {
        console.log('catch', e);
      });;
  }
  stopSpacesInPassword(ev) {
    console.log(ev);
    this.changeData.old_password = ev.target.value.trim();
  }
  stopSpacesInNewPassword(ev) {
    console.log(ev);
    this.changeData.new_password = ev.target.value.trim();
  }
}
